import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function Terminos() {
  return (
    <div className="min-h-screen bg-[#080a0f] text-white flex flex-col">
      <Navbar />
      <main className="flex-1 max-w-4xl mx-auto px-6 py-20 w-full">
        <h1 className="text-3xl font-bold text-white mb-2">Términos de Uso</h1>
        <p className="text-[#6b7280] text-sm mb-10">Última actualización: 1 de abril de 2025</p>

        <div className="space-y-10 text-[#a8b2c1] text-sm leading-relaxed">

          <section>
            <h2 className="text-white text-lg font-semibold mb-3">1. Aceptación de los términos</h2>
            <p>
              Al acceder y utilizar la plataforma Apuestamente (en adelante, "la Plataforma"), el usuario acepta quedar vinculado por los presentes Términos de Uso. Si no está de acuerdo con alguno de estos términos, le rogamos que no utilice la Plataforma.
            </p>
          </section>

          <section>
            <h2 className="text-white text-lg font-semibold mb-3">2. Descripción del servicio</h2>
            <p>
              Apuestamente es una plataforma de análisis deportivo, estadísticas y comparación de cuotas de apuestas. La Plataforma no opera como casa de apuestas ni acepta depósitos o apuestas de ningún tipo. Toda la información proporcionada tiene carácter meramente informativo y analítico.
            </p>
          </section>

          <section>
            <h2 className="text-white text-lg font-semibold mb-3">3. Requisitos de edad</h2>
            <p>
              El acceso a la Plataforma está restringido a mayores de 18 años. Al registrarse, el usuario declara tener la edad mínima requerida. Apuestamente se reserva el derecho de solicitar verificación de edad en cualquier momento.
            </p>
          </section>

          <section>
            <h2 className="text-white text-lg font-semibold mb-3">4. Registro y cuenta de usuario</h2>
            <p>
              Para acceder a determinadas funcionalidades, el usuario deberá crear una cuenta proporcionando información veraz y actualizada. El usuario es responsable de mantener la confidencialidad de sus credenciales de acceso y de todas las actividades realizadas bajo su cuenta.
            </p>
          </section>

          <section>
            <h2 className="text-white text-lg font-semibold mb-3">5. Planes de suscripción</h2>
            <p>
              Apuestamente ofrece planes de suscripción de pago que otorgan acceso a funcionalidades avanzadas. Los precios, características y condiciones de cada plan se detallan en la sección de precios de la Plataforma. Las suscripciones se renuevan automáticamente salvo cancelación expresa por parte del usuario.
            </p>
          </section>

          <section>
            <h2 className="text-white text-lg font-semibold mb-3">6. Uso aceptable</h2>
            <p className="mb-3">El usuario se compromete a no utilizar la Plataforma para:</p>
            <ul className="list-disc list-inside space-y-1 pl-2">
              <li>Actividades ilegales o fraudulentas.</li>
              <li>Distribuir contenido ofensivo, difamatorio o que infrinja derechos de terceros.</li>
              <li>Intentar acceder sin autorización a sistemas o datos de la Plataforma.</li>
              <li>Realizar scraping masivo o uso automatizado no autorizado de la API.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-white text-lg font-semibold mb-3">7. Propiedad intelectual</h2>
            <p>
              Todos los contenidos, marcas, logotipos, diseños y software de la Plataforma son propiedad de Apuestamente o de sus licenciantes y están protegidos por la legislación de propiedad intelectual aplicable. Queda prohibida su reproducción total o parcial sin autorización expresa.
            </p>
          </section>

          <section>
            <h2 className="text-white text-lg font-semibold mb-3">8. Limitación de responsabilidad</h2>
            <p>
              La información proporcionada en la Plataforma tiene carácter orientativo. Apuestamente no garantiza la exactitud, completitud o actualidad de los datos y no se hace responsable de las decisiones de apuesta tomadas por los usuarios basándose en dicha información. Las apuestas conllevan riesgo de pérdida económica.
            </p>
          </section>

          <section>
            <h2 className="text-white text-lg font-semibold mb-3">9. Modificaciones</h2>
            <p>
              Apuestamente se reserva el derecho de modificar estos Términos en cualquier momento. Los cambios serán notificados a los usuarios registrados y entrarán en vigor a los 15 días de su publicación. El uso continuado de la Plataforma tras dicho plazo implica la aceptación de los nuevos términos.
            </p>
          </section>

          <section>
            <h2 className="text-white text-lg font-semibold mb-3">10. Legislación aplicable</h2>
            <p>
              Estos Términos se rigen por la legislación española. Para cualquier controversia derivada del uso de la Plataforma, las partes se someten a los juzgados y tribunales de Madrid, con renuncia expresa a cualquier otro fuero que pudiera corresponderles.
            </p>
          </section>

          <section>
            <h2 className="text-white text-lg font-semibold mb-3">11. Contacto</h2>
            <p>
              Para cualquier consulta relacionada con estos Términos, puede contactarnos en{' '}
              <a href="mailto:apuestamente@gmail.com" className="text-[#00e87a] hover:underline">
                apuestamente@gmail.com
              </a>.
            </p>
          </section>

        </div>
      </main>
      <Footer />
    </div>
  );
}
